import dayjs from 'dayjs';

const remindFrame = dayjs().subtract(1, 'h');

export function canRemindSubscriber(lastEmailSentAt: Date): boolean {
  return dayjs(lastEmailSentAt).isBefore(remindFrame);
}
